import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";

type HeaderProps = {
  className?: string;
} & ComponentProps<"header">;

export const Header = ({ className, ...props }: HeaderProps) => (
  <header
    className={cn(
      "tw:!flex tw:justify-between tw:items-center tw:py-2.5 tw:sm:py-4.25 tw:px-3 tw:border tw:border-solid tw:rounded-t-lg tw:border-fill-quinary tw:!border-b-0",
      className,
    )}
    {...props}
  />
);
